import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

// The Hint Bubble Component Tests card's body on the Test UI Components page: a static hint bubble,
// one toggled by a button, and a dismissible one.
@Component({
  selector: 'cs-test-hint-bubble-card',
  host: { class: 'showcase-card-body' },
  templateUrl: 'cs-test-hint-bubble-card.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestHintBubbleCardComponent {
  showDynamicHint = false;

  constructor(private cd: ChangeDetectorRef) {}

  // Toggle dynamic hint bubble
  toggleDynamicHint() {
    this.showDynamicHint = !this.showDynamicHint;
    this.cd.markForCheck();
  }
}
